import React from 'react';
import { Box, Container, Typography, IconButton, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const BeRightBack = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #7a4e99 0%, #8e5fb2 50%, #b08ac9 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: 4,
            p: { xs: 3, md: 5 },
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 3 }}>
            <img
              src="/images/content/logo.jpeg"
              alt="Stylist Inside Logo"
              style={{ maxHeight: 120, width: 'auto' }}
            />
          </Box>

          {/* Be Right Back Message */}
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              color: '#7a4e99',
              mb: 2,
              fontSize: { xs: '1.75rem', md: '2.5rem' },
            }}
          >
            Be Right Back!
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: '#666',
              mb: 4,
              fontWeight: 400,
              lineHeight: 1.6,
            }}
          >
            The Florida location has moved! 
          </Typography>

          {/* Owner Section */}
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                width: 150,
                height: 150,
                borderRadius: '50%',
                overflow: 'hidden',
                border: '4px solid #a88685',
                boxShadow: 3,
                mx: 'auto',
                mb: 2,
              }}
            >
              <img
                src="/images/team/tabitha-anton.png"
                alt="Tabitha (Anton) Spedale"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: '#4a4a4a',
                mb: 0.5,
              }}
            >
              Tabitha (Anton) Spedale
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#757575',
                fontStyle: 'italic',
              }}
            >
              Owner & Master Hair Stylist
            </Typography>
          </Box>

          {/* Contact Section */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: '#4a4a4a',
                mb: 2,
                textTransform: 'uppercase',
                letterSpacing: 1,
              }}
            >
              Stay in Touch
            </Typography>

            {/* Email */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <EmailIcon sx={{ color: '#7a4e99', mr: 1 }} />
              <Link
                href="mailto:tabithaanton@stylistinside.com"
                sx={{
                  color: '#7a4e99',
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                tabithaanton@stylistinside.com
              </Link>
            </Box>

            {/* Social Media */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 3 }}>
              <IconButton
                href="https://facebook.com/stylistinside"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  bgcolor: '#7a4e99',
                  color: 'white',
                  '&:hover': {
                    bgcolor: '#5c3a75',
                  },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="https://www.instagram.com/stylistinside.tabithaanton/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  bgcolor: '#7a4e99',
                  color: 'white',
                  '&:hover': {
                    bgcolor: '#5c3a75',
                  },
                }}
              >
                <InstagramIcon />
              </IconButton>
            </Box>

            {/* Online Store Button */}
            <Box
              component="a"
              href="https://shop.saloninteractive.com/store/StylistInside?utm_source=SalonInteractive&utm_medium=web&utm_campaign=ShareMyStore"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: '#a88685',
                color: 'white',
                px: 3,
                py: 1.5,
                borderRadius: 3,
                textDecoration: 'none',
                fontWeight: 600,
                transition: 'all 0.3s ease',
                '&:hover': {
                  bgcolor: '#8a6c6b',
                  transform: 'translateY(-2px)',
                  boxShadow: 3,
                },
              }}
            >
              <ShoppingCartIcon />
              Visit the Online Store
            </Box>
          </Box>

          {/* Footer */}
          <Typography
            variant="body2"
            sx={{
              color: '#999',
              mt: 4,
              pt: 3,
              borderTop: '1px solid #eee',
            }}
          >
            © {new Date().getFullYear()} Stylist Inside Salon. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default BeRightBack;
